import(/* webpackMode: "eager" */ "/srv/p100/srv/www/netonlinemedia.com/public/netonlinemedia/node_modules/next/dist/client/link.js");
